import { CircleProps } from '@nivo/swarmplot'
import { ComparisonDatum } from 'ComponentLibrary/src/molecules/ComparisonChart/types'
import { tokens } from 'ComponentLibrary/style-dictionary/output'

export const ComparisonChartCircle = ({ node, onClick, onMouseMove, onMouseLeave, onMouseEnter }: CircleProps<ComparisonDatum>) => (
    <g transform={`translate(${node.x}, ${node.y})`} key={node.id}>
        <circle
            cy={-14}
            r={5.5}
            strokeWidth={2}
            fill={node.data.color}
            stroke={tokens.ColorBorderInverse}
            filter="drop-shadow(0px 0px 10px rgba(8, 18, 74, 0.10))"
        />
        <rect
            fill="transparent"
            cursor="pointer"
            x={-8}
            width={16}
            y={-26}
            height={52}
            onMouseMove={(event) => onMouseMove?.(node, event)}
            onMouseEnter={(event) => onMouseEnter?.(node, event)}
            onMouseLeave={(event) => onMouseLeave?.(node, event)}
            onClick={(event) => onClick?.(node, event)}
        />
    </g>
)
